import type { Dto } from "../types/be/Dto";
import type { ResourcePageDto } from "../types/be/ResourcePageDto";
import type { Entity } from "../types/fe/Entity";

export const defaultMapper = (input: Dto | Entity | ResourcePageDto<Dto>) => input;
